<div class="d-flex justify-content-end my-0">
  <mwe-button
    buttonId="mwe-ummeldung-instructions"
    [category]="'secondary'"
    labelKey="ummeldung.instructions.open"
    prependIconClass="fas fa-book"
    (clicked)="openInstructions()"
  />
</div>
